import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { enGB } from 'date-fns/locale'

function checkDateValid(object) {
    if (object === null) {
        return false;
    }
    const date = new Date(object);
    return !isNaN(date.valueOf());
}

const DateRangeSelector = ({ fromDate, toDate, onFromDateChange, onToDateChange, small, hideTitle }) => {
    const { t } = useTranslation();
    return (
        <Stack direction="row" spacing={2}>
            {!hideTitle &&
                <Typography component="h2" variant="h6" color="primary">
                    {t("Date")}
                </Typography>
            }
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                <DatePicker
                    label={t("From")}
                    value={fromDate}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newValue) => {
                        if (checkDateValid(newValue)) {
                            onFromDateChange(newValue);
                        }
                    }}
                    renderInput={(params) => small ? <TextField fullWidth size="small" {...params} /> : <TextField {...params} />}
                />
                <DatePicker
                    label={t("To")}
                    value={toDate}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newValue) => {
                        if (checkDateValid(newValue)) {
                            onToDateChange(newValue);
                        }
                    }}
                    renderInput={(params) => small ? <TextField fullWidth size="small" {...params} /> : <TextField {...params} />}
                />
            </LocalizationProvider>
        </Stack>

    )
}

export default DateRangeSelector